import { render, staticRenderFns } from "./addInsurance.vue?vue&type=template&id=06ef615d&scoped=true&"
import script from "./addInsurance.vue?vue&type=script&lang=js&"
export * from "./addInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef615d",
  null
  
)

export default component.exports